/* Englischer Sprachkatalog. Schlüssel ist der deutsche Quelltext. */

const texte = {
  "Rot": "Red",
  "Weiß": "White",
  "Rosé": "Rosé",
  "Schaumwein": "Sparkling",
  "Edelsüß": "Noble sweet",
  "Orange": "Orange",
  "Gespritet": "Fortified",
  "100-Punkte-Skala": "100-point scale",
  "20-Punkte-Skala": "20-point scale",
  "5-Sterne-Skala": "5-star scale",
  "Prozent-Skala": "Percentage scale",
  "0,375 l · Halbe Flasche": "0.375 l · Half bottle",
  "0,5 l · Süßweinflasche": "0.5 l · Dessert wine",
  "0,75 l · Standard": "0.75 l · Standard",
  "1,5 l · Magnum": "1.5 l · Magnum",
  "3 l · Doppelmagnum": "3 l · Double magnum",
  "6 l · Imperial": "6 l · Imperial",
  "Name A–Z": "Name A–Z",
  "Name Z–A": "Name Z–A",
  "Jahrgang jung–alt": "Vintage, newest first",
  "Jahrgang alt–jung": "Vintage, oldest first",
  "Jahrgang, neueste zuerst": "Vintage, newest first",
  "Jahrgang, älteste zuerst": "Vintage, oldest first",
  "Preis hoch–niedrig": "Price, high to low",
  "Preis niedrig–hoch": "Price, low to high",
  "Preis aufsteigend": "Price, low to high",
  "Preis absteigend": "Price, high to low",
  "Bewertung hoch–niedrig": "Rating, high to low",
  "Bewertung niedrig–hoch": "Rating, low to high",
  "Bestand, meiste zuerst": "Stock, most first",
  "Jede Trinkreife": "Any drinking window",
  "Noch nicht trinkreif": "Not yet ready",
  "Trinkreif": "Ready to drink",
  "Überfällig": "Past its peak",
  "Weinkarte": "Wine list",
  "Weinkeller": "Wine cellar",
  "Keller": "Cellar",
  "Weine": "Wines",
  "Winzer": "Producers",
  "Regionen": "Regions",
  "Karte": "List",
  "Filter": "Filters",
  "Sortierung": "Sorting",
  "Zurücksetzen": "Reset",
  "Zurück": "Back",
  "Nur ansehen": "View only",
  "Wird geladen …": "Loading …",
  "Alle Typen": "All types",
  "Alle Jahrgänge": "All vintages",
  "Alle Länder": "All countries",
  "Alle Regionen": "All regions",
  "Alle Winzer": "All producers",
  "Alle Rebsorten": "All grape varieties",
  "Alle Labels": "All labels",
  "andere Suche": "different search",
  "Für diesen Winzer sind noch keine Weine im Katalog.": "No wines from this producer in the catalogue yet.",
  "Ein Wein dieses Winzers im Katalog:": "One wine from this producer in the catalogue:",
  "{n} Weine dieses Winzers im Katalog:": "{n} wines from this producer in the catalogue:",
  "Eigenen Wein dieses Winzers anlegen": "Add your own wine from this producer",
  "Aus dem Katalog": "From the catalogue",
  "Eigener Jahrgang": "Own vintage",
  "Kritiken": "Reviews",
  "Witterung": "Weather",
  "Ohne Winzer": "No producer",
  "Ohne Region": "No region",
  "Ohne Land": "No country",
  "Diese Weinkarte ist noch leer.": "This wine list is still empty.",
  "Geteilt über WineLake · schreibgeschützte Ansicht": "Shared via WineLake · read-only view",
  "Keine Flaschen im Bestand.": "No bottles in stock.",
  "Keine Positionen gefunden.": "No entries found.",
  "Keine Regionen gefunden.": "No regions found.",
  "Keine Weine gefunden.": "No wines found.",
  "Keine Winzer gefunden.": "No producers found.",
  "Weine auf dieser Karte": "Wines on this list",
  "Der Server ist nicht erreichbar.": "The server cannot be reached.",
  "Diese Freigabe ist nicht verfügbar.": "This share is not available.",
  "Etikett vergrößern": "Enlarge label",
  "Etikett": "Label",
  "Mittel": "Average",
  "Wärmesumme": "Growing degree days",
  "Niederschlag": "Rainfall",
  "Sonne": "Sunshine",
  "Hitzetage": "Hot days",
  "Frosttage": "Frost days",
  "Verkostung": "Tasting",
  "Wein": "Wine",
  "Vegetationsperiode {zeitraum}": "Growing season {zeitraum}",
  "Trinkfenster {von}–{bis}": "Drinking window {von}–{bis}",
  "Zurück zu Winzern": "Back to producers",
  "Zurück zu Regionen": "Back to regions",
  "{n} Fl.": "{n} btl.",
  "ein Wein": "1 wine",
  "{n} Weine": "{n} wines",
  "Rückmeldung": "Feedback",
  "Fehler gefunden, etwas vermisst oder eine Idee? Schreib mir gern — jede Rückmeldung hilft.": "Found a bug, missing something or have an idea? Do write — every message helps.",
  "Einführung": "Introduction",
  "Ein Überblick über die wichtigsten Funktionen. Die Abschnitte lassen sich einzeln aufklappen.": "An overview of the main features. Each section can be opened on its own.",
  "{n} Wein": "{n} wine",
  "{n} Position": "{n} item",
  "{n} Positionen": "{n} items",
  "Sprache der Karte": "Language of the list",
  "Automatisch (Sprache des Gastes)": "Automatic (guest’s language)",
  "Aktualisieren": "Refresh",
  "Statistik": "Statistics",
  "Nur mit Bestand": "In stock only",
  "Mein Konto": "My account",
  "Teilen": "Sharing",
  "Katalog": "Catalogue",
  "Daten": "Data",
  "Verwaltung": "Administration",
  "Menü": "Menu",
  "Datenstand": "Data status",
  "Datenhaltung": "Data storage",
  "Abmelden": "Sign out",
  "Keller löschen": "Delete cellar",
  "E-Mail & Passwort": "Email & password",
  "Keller teilen": "Share cellar",
  "Weinkarten": "Wine lists",
  "Änderungen": "Changes",
  "Meine Vorschläge": "My proposals",
  "Vorschläge prüfen": "Review proposals",
  "Zusammenführen": "Merge duplicates",
  "Wetterdaten laden": "Load weather data",
  "Excel exportieren": "Export to Excel",
  "Excel importieren": "Import from Excel",
  "Leere Vorlage": "Blank template",
  "Cloud": "Cloud",
  "Lokal": "Local",
  "Admin": "Admin",
  "Wird gespeichert …": "Saving …",
  "Prüfe …": "Checking …",
  "Offline — lokal gesichert": "Offline — saved locally",
  "Synchronisiert · Stand {v}": "Synchronised · version {v}",
  "Stammdaten aus dem gemeinsamen Katalog übernehmen.": "Adopt master data from the shared catalogue.",
  "Nur deine eigenen Daten, kein Katalog.": "Only your own data, no catalogue.",
  "Die Katalog-Synchronisation wurde für dieses Konto abgeschaltet. Deine eigenen Daten bleiben nutzbar.": "Catalogue synchronisation is switched off for this account. Your own data remains usable.",
  "Sprache": "Language",
  "Jahrgang": "Vintage",
  "Typ": "Type",
  "Region": "Region",
  "Land": "Country",
  "Bestand": "Stock",
  "Flaschen": "Bottles",
  "Positionen": "Entries",
  "Preis": "Price",
  "Lager": "Storage",
  "Kritik": "Rating",
  "Kellerwert": "Cellar value",
  "Wein anlegen": "Add wine",
  "Keller durchsuchen …": "Search cellar …",
  "Lieblingswein": "Favourite",
  "Keine Positionen gefunden. Lege einen Wein an oder passe Suche und Filter an.": "No entries found. Add a wine or adjust search and filters.",
  "Alle Weine": "All wines",
  "Nur Lieblingsweine": "Favourites only",
  "Alle Lagerorte": "All storage places",
  "Filter zurücksetzen": "Reset filters",
  "Bestand hoch–niedrig": "Stock, high to low",
  "Bestand niedrig–hoch": "Stock, low to high",
  "Trinkreife alt–jung": "Drinking window, oldest first",
  "Trinkreife jung–alt": "Drinking window, newest first",
  "Bearbeiten": "Edit",
  "Öffnen": "Open",
  "Zur Weinliste": "To the wine list",
  "Zum Wein": "To the wine",
  "Zur Winzerliste": "To the producer list",
  "Zu den Regionen": "To the regions",
  "Zurück zu den Ländern": "Back to countries",
  "Im Keller zeigen": "Show in cellar",
  "Jahrgänge": "Vintages",
  "Winzer anlegen": "Add producer",
  "Region anlegen": "Add region",
  "Jahrgang anlegen": "Add vintage",
  "Kritik erfassen": "Add rating",
  "Wein löschen": "Delete wine",
  "Winzer löschen": "Delete producer",
  "Region löschen": "Delete region",
  "Jahrgang löschen": "Delete vintage",
  "Entfernen": "Remove",
  "Vergrößern": "Enlarge",
  "Bewertung": "Rating",
  "Kritiker / Quelle": "Critic / source",
  "Anlass / Pairing": "Occasion / pairing",
  "Notiz": "Note",
  "Trinkfenster": "Drinking window",
  "Ein- & Auslagerungen": "Stock movements",
  "Eingelagert": "Added",
  "Entnommen": "Removed",
  "Auf Weinkarte": "On wine list",

  /* Trinkverlauf */
  "Trinkverlauf": "Cellar log",
  "Einlagerungen": "Stock-ins",
  "Entnahmen": "Withdrawals",
  "Art der Bewegung": "Type of movement",
  "Alle Jahre": "All years",
  "Jahr": "Year",
  "Suchen": "Search",
  "Wein, Winzer, Händler …": "Wine, producer, merchant …",
  "eingelagert": "added",
  "ausgelagert": "removed",
  "Saldo": "Balance",
  "Jg.": "Vtg.",
  "Ohne Datum": "Undated",
  "Unbekannter Wein": "Unknown wine",
  "Zu dieser Auswahl gibt es keine Bewegungen.": "No movements match this selection.",
  "Noch keine Ein- oder Auslagerungen erfasst. Sobald du Flaschen einlagerst oder entnimmst, entsteht hier der Verlauf.": "No stock movements recorded yet. As soon as you add or remove bottles, your log will appear here.",
  "Alk.": "Alc.",
  "Säure": "Acidity",
  "Ausbau": "Maturation",
  "Geschmack": "Taste",
  "Boden": "Soil",
  "Dieser Wein existiert nicht mehr.": "This wine no longer exists.",
  "Kein Jahrgang dieses Weins hat aktuell Bestand. Deaktiviere „Nur mit Bestand“, um alle zu sehen.": "No vintage of this wine is currently in stock. Switch off “In stock only” to see all.",
  "Noch kein Jahrgang erfasst. Lege den ersten Jahrgang mit Analysewerten und Anfangsbestand an.": "No vintage recorded yet. Add the first one with analysis values and opening stock.",
  "Noch keine Kritiken erfasst.": "No reviews yet.",
  "Analyse & Kellerdaten": "Analysis & cellar data",
  "Alkohol": "Alcohol",
  "Restzucker": "Residual sugar",
  "Schwefel": "Sulphur",
  "Zuckerkategorie": "Sweetness category",
  "Reife": "Maturity",
  "Verschluss": "Closure",
  "Kapsel": "Capsule",
  "Lagerort": "Storage place",
  "Preis (Flasche)": "Price (bottle)",
  "Ø Einstand": "Ø cost price",
  "Flaschen im Bestand": "Bottles in stock",
  "Bezugsquellen": "Sources",
  "Zugang": "Add stock",
  "Entnehmen": "Remove stock",
  "Neu aufnehmen": "Add new",
  "Etikettenfoto hinzufügen": "Add label photo",
  "Bild wählen": "Choose image",
  "Wird hochgeladen …": "Uploading …",
  "Dieser Jahrgang existiert nicht mehr.": "This vintage no longer exists.",
  "Für diesen Jahrgang ist noch keine Kritik erfasst.": "No rating recorded for this vintage yet.",
  "Für Weine ohne Jahrgang (N.V.) gibt es keine jahresbezogene Witterung.": "Wines without a vintage (N.V.) have no year-specific weather data.",
  "Ort": "Town",
  "Rebsorten": "Grape varieties",
  "Winzer durchsuchen …": "Search producers …",
  "Nach Land filtern": "Filter by country",
  "Nach Region filtern": "Filter by region",
  "Nach Rebsorte filtern": "Filter by grape variety",
  "Nach Label filtern": "Filter by label",
  "Dieser Winzer existiert nicht mehr.": "This producer no longer exists.",
  "Für diesen Winzer ist noch kein Wein erfasst.": "No wine recorded for this producer yet.",
  "Kein Wein dieses Winzers hat aktuell Bestand. Deaktiviere „Nur mit Bestand“, um alle zu sehen.": "No wine from this producer is currently in stock. Switch off “In stock only” to see all.",
  "Keine Winzer gefunden. Lege einen Winzer an oder passe Suche und Filter an.": "No producers found. Add one or adjust search and filters.",
  "Zuerst die Weine dieses Winzers löschen oder umziehen.": "Delete or move this producer’s wines first.",
  "Alle": "All",
  "Appellation": "Appellation",
  "Appellationen": "Appellations",
  "Koordinaten": "Coordinates",
  "Weine dieser Region": "Wines from this region",
  "Weinen": "wines",
  "Länder & Regionen durchsuchen …": "Search countries & regions …",
  "Diese Region existiert nicht mehr.": "This region no longer exists.",
  "Aus dieser Region ist noch kein Wein erfasst.": "No wine recorded from this region yet.",
  "Noch keine Beschreibung hinterlegt.": "No description yet.",
  "Noch keine Winzer in dieser Region.": "No producers in this region yet.",
  "Kein Land gefunden. Passe Suche und Filter an oder lege eine Region an.": "No country found. Adjust search and filters or add a region.",
  "Keine Region gefunden — Suche und Filter anpassen oder eine Region anlegen.": "No region found — adjust search and filters or add a region.",
  "Keine Region gefunden. Passe die Suche an oder lege eine Region an.": "No region found. Adjust the search or add a region.",
  "Kein Wein dieser Region hat aktuell Bestand. Deaktiviere „Nur mit Bestand“, um alle zu sehen.": "No wine from this region is currently in stock. Switch off “In stock only” to see all.",
  "Zuerst die Winzer dieser Region löschen oder umziehen.": "Delete or move this region’s producers first.",
  "Abbrechen": "Cancel",
  "Schließen": "Close",
  "Löschen": "Delete",
  "Anlegen": "Create",
  "Speichern": "Save",
  "Auswählen …": "Select …",
  "Wählen …": "Choose …",
  "Name": "Name",
  "Datum": "Date",
  "Menge": "Quantity",
  "Größe": "Size",
  "Fl.": "btl.",
  "Quelle": "Source",
  "Ziel": "Target",
  "Stand": "Version",
  "Zuletzt": "Last active",
  "Offen": "Open",
  "Gesperrt": "Closed",
  "Wetter": "Weather",
  "Benutzername": "Username",
  "Registriert": "Registered",
  "Registrierung": "Registration",
  "E-Mail": "Email",
  "Passwort ändern": "Change password",
  "Bisheriges Passwort": "Current password",
  "Neues Passwort": "New password",
  "Neues Passwort wiederholen": "Repeat new password",
  "Neues Passwort setzen": "Set a new password",
  "E-Mail oder Benutzername": "Email or username",
  "Zur Anmeldung": "To sign-in",
  "Jetzt anmelden": "Sign in now",
  "Link wird geprüft …": "Checking link …",
  "Konto löschen": "Delete account",
  "Weintyp": "Wine type",
  "Alkohol (% vol)": "Alcohol (% vol)",
  "Säure (g/l)": "Acidity (g/l)",
  "Restzucker (g/l)": "Residual sugar (g/l)",
  "Trinkfenster von": "Drinking window from",
  "Trinkfenster bis": "Drinking window until",
  "Flaschengröße": "Bottle size",
  "Anfangsbestand (0,75-l-Flaschen)": "Opening stock (0.75 l bottles)",
  "Kaufpreis je Flasche (€)": "Purchase price per bottle (€)",
  "Kaufdatum": "Purchase date",
  "Bezugsquelle": "Supplier",
  "Zugang buchen": "Add stock",
  "Verkostungsnotiz": "Tasting note",
  "Bewertungsschema": "Rating scale",
  "Anlass": "Occasion",
  "Speisenbegleitung (Pairing)": "Food pairing",
  "Kritik speichern": "Save rating",
  "Der Zugang wird dem Bestand der gewählten Flaschengröße gutgeschrieben. Bezugsquelle und Kaufpreis fließen in die Kaufhistorie ein.": "The addition is credited to the stock of the chosen bottle size. Supplier and purchase price feed into the buying history.",
  "Nach der Entnahme kannst du direkt eine Verkostungsnotiz zum Jahrgang erfassen.": "After removing a bottle you can add a tasting note for the vintage right away.",
  "Für diesen Jahrgang ist kein Bestand vorhanden — buche zuerst einen Zugang.": "No stock for this vintage — record an addition first.",
  "Für diesen Wein existiert noch kein Jahrgang. Lege zuerst einen Jahrgang an, um Kritiken zu erfassen.": "This wine has no vintage yet. Add a vintage first to record ratings.",
  "Neue Region": "New region",
  "Neuer Winzer": "New producer",
  "Region suchen …": "Search region …",
  "Winzer suchen …": "Search producer …",
  "Kurzbeschreibung": "Short description",
  "Klassifikation": "Classification",
  "Wichtige Rebsorten": "Key grape varieties",
  "Anteil in Prozent": "Share in percent",
  "Rebsorte entfernen": "Remove grape variety",
  "Breitengrad": "Latitude",
  "Längengrad": "Longitude",
  "Titel der Weinkarte": "Title of the wine list",
  "Titel der neuen Weinkarte": "Title of the new wine list",
  "Sichtbare Angaben": "Visible details",
  "Diese Weinkarte teilen": "Share this wine list",
  "Widerrufen": "Revoke",
  "Preis (€)": "Price (€)",
  "Preis (€ / Flasche)": "Price (€ / bottle)",
  "Wein aus dem Keller wählen …": "Choose a wine from the cellar …",
  "Zurück in den Keller": "Back to the cellar",
  "Eine Flasche als ausgeschenkt buchen": "Record one bottle as served",
  "Noch keine Flaschen auf dieser Karte.": "No bottles on this list yet.",
  "Noch keine Weinkarten.": "No wine lists yet.",
  "Noch kein Freigabe-Link vorhanden.": "No share link yet.",
  "Im Keller liegen keine Flaschen, die sich auf eine Weinkarte setzen ließen.": "There are no bottles in the cellar to put on a wine list.",
  "Als PDF speichern / drucken": "Save as PDF / print",
  "Annehmen": "Accept",
  "Ablehnen": "Reject",
  "Entschieden": "Decided",
  "Zuletzt entschieden": "Recently decided",
  "Keine offenen Vorschläge.": "No open proposals.",
  "Nichts offen.": "Nothing open.",
  "Katalogfassung übernehmen": "Adopt catalogue version",
  "Noch keine Änderungen, die dich betreffen.": "No changes affecting you yet.",
  "Bleibt bei dir erhalten und wird ab jetzt rein lokal geführt.": "Stays with you and will be kept purely local from now on.",
  "Dieses Objekt wird bei dir lokal geführt und nicht mehr abgeglichen.": "This item is kept local and no longer synchronised.",
  "Nur Jahrgänge oder Rebsorten betroffen.": "Only vintages or grape varieties affected.",
  "Begründung (nur bei Ablehnung sinnvoll)": "Reason (useful when rejecting)",
  "Mögliche Dubletten": "Possible duplicates",
  "Vorschau": "Preview",
  "Richtung tauschen": "Swap direction",
  "Jetzt zusammenführen": "Merge now",
  "Im Katalog zusammenführen": "Merge in the catalogue",
  "Quelle — geht auf und verschwindet": "Source — merged and removed",
  "Quelle — verschwindet": "Source — will be removed",
  "Ziel — bleibt bestehen": "Target — will remain",
  "Ziel — bleibt": "Target — remains",
  "Quelle und Ziel müssen verschieden sein.": "Source and target must differ.",
  "Hier gibt es noch nichts zusammenzuführen.": "Nothing to merge here yet.",
  "Dieser Schritt kann nicht rückgängig gemacht werden.": "This step cannot be undone.",
  "Bereich": "Area",
  "Neu angelegt": "Newly created",
  "Aktualisiert / verknüpft": "Updated / linked",
  "Übersprungen": "Skipped",
  "Hinweise": "Notes",
  "Betroffen": "Affected",
  "Keine Konten vorhanden.": "No accounts.",
  "Registrierung öffnen oder sperren": "Open or close registration",
  "Teilen & Weinkarten": "Sharing & wine lists",
  "Wetterdaten für dieses Konto freischalten": "Enable weather data for this account",
  "Keller teilen und Weinkarten für dieses Konto freischalten": "Enable sharing and wine lists for this account",
  "Nimmt dieses Konto am gemeinsamen Katalog teil? Abschalten stoppt Zulieferungen und Aktualisierungen.": "Does this account take part in the shared catalogue? Switching it off stops contributions and updates.",
  "Alle aktualisieren": "Refresh all",
  "{n} Klimareihen vom Server": "{n} climate series from the server",
  "bis zu {n} Jahrgänge vom Server": "up to {n} vintages from the server",
  "{n} Jahrgänge aus der Klimareihe, ohne Abruf": "{n} vintages from the climate series, no request",
  "Die Wetterdaten werden geladen. Bitte das Fenster geöffnet lassen. Was schon geholt ist, liegt auch auf dem Server bereit.": "Weather data is loading. Please keep this window open. Anything already fetched is also kept on the server.",
  "Minutengrenze bei Open-Meteo erreicht — es geht in {n} s weiter.": "Open-Meteo per-minute limit reached — continuing in {n} s.",
  "Abgebrochen — das Kontingent bei Open-Meteo ist für den Moment erschöpft.": "Stopped — the Open-Meteo quota is used up for now.",
  "Noch offen: {n}. Was schon geholt ist, bleibt erhalten — später erneut „Nur fehlende auffüllen“ wählen.": "Still open: {n}. Everything fetched so far is kept — choose “Fill in missing only” again later.",
  "Nichts zu tun": "Nothing to do",
  "Ohne Vegetationsdaten sind Jahrgänge, deren Saison noch nicht begonnen hat — das ist normal.": "Vintages without growing-season data are those whose season has not started yet — that is normal.",
  "Letzter Fehler: {text}": "Last error: {text}",
  "Fertig. Fehlende Daten wurden aufgefüllt.": "Done. Missing data has been filled in.",
  "Fertig. Alle Daten wurden aktualisiert.": "Done. All data has been refreshed.",
  "Klimareihen geladen": "Climate series loaded",
  "Jahrgänge vom Server": "Vintages from the server",
  "Jahrgänge aus der Klimareihe": "Vintages from the climate series",
  "Ohne Vegetationsdaten": "No growing-season data",
  "Fehler": "Errors",
  "Klimareihen und Witterung für {r} Regionen und {j} Jahrgänge im Bestand.": "Climate series and weather for {r} regions and {j} vintages in stock.",
  "{n} Regionen ohne Koordinaten werden übersprungen.": "{n} regions without coordinates are skipped.",
  "{n} Klimareihen fehlt der jüngste abgeschlossene Jahrgang oder sein vollständiger Nachlauf.": "{n} climate series lack the latest completed vintage or its full post-harvest period.",
  "Alles bereits vorhanden — nichts zu laden.": "Everything is already there — nothing to load.",
  "Der Server hält Klimareihen vorrätig; Open-Meteo wird nur für Fehlendes gefragt. Eine Region zum ersten Mal kostet dort viel Kontingent — wird es knapp, hält der Lauf an und sagt es.": "The server keeps climate series on hand; Open-Meteo is only asked for what is missing. A region’s first load uses a lot of quota there — if it runs short, the run stops and tells you.",
  "Nur fehlende auffüllen": "Fill in missing only",
  "Erneut versuchen": "Try again",
  "Verstanden": "Understood",
  "Lädt …": "Loading …",
  "Übersicht wird geladen …": "Loading overview …",
  "Neu geladen": "Reloaded",
  "Ohne verfügbare Daten": "No data available",
  "Foto nicht abrufbar": "Photo unavailable",
  "Standard (Name A–Z)": "Default (name A–Z)",
  "Die Excel-Datei wurde eingelesen und mit deinem Keller zusammengeführt.": "The Excel file has been read and merged with your cellar.",
  "Die Wetterdaten werden von Open-Meteo geladen. Bitte das Fenster geöffnet lassen.": "Weather data is loaded from Open-Meteo. Please keep this window open.",
  "Einzelne Jahrgänge liefern keine Vegetationsdaten (z. B. sehr junge oder zukünftige Jahrgänge) — das ist normal.": "Some vintages provide no growing-season data (e.g. very recent or future ones) — that is normal.",
  "+ Weitere Rebsorte": "+ Another grape variety",
  "Einen Moment …": "One moment …",
  "Adresse aktualisieren": "Update address",
  "Adresse speichern": "Save address",
  "Link anfordern": "Request link",
  "Passwort setzen": "Set password",
  "Anmelden": "Sign in",
  "Registrieren": "Register",
  "Passwort": "Password",
  "Passwort wiederholen": "Repeat password",
  "Passwort vergessen?": "Forgotten your password?",
  "Einladungscode": "Invitation code",
  "Anmeldung wird geprüft …": "Checking sign-in …",
  "Kellerbuch wird geöffnet …": "Opening the cellar book …",
  "Hauptnavigation": "Main navigation",
  "Kontomodus": "Account mode",
  "Kellerbuch & Jahrgangsarchiv": "Cellar book & vintage archive",
  "WineLake · Witterung: Open-Meteo Historical Weather API · Karten: OpenStreetMap-Mitwirkende": "WineLake · Weather: Open-Meteo Historical Weather API · Maps: OpenStreetMap contributors",
  "Änderungen im Katalog": "Catalogue changes",
  "Katalog-Vorschläge": "Catalogue proposals",
  "Getrunken": "Consumed",
  "Aus Weinkarten": "From wine lists",
  "Wert": "Value",
  "Einkauf": "Purchase",
  "Verkauf": "Sale",
  "Gewinn": "Profit",
  "Kennzahl": "Metric",
  "Kennzahlen im Vergleich": "Metrics compared",
  "Alle Kalenderjahre": "All calendar years",
  "Alle Weinkarten": "All wine lists",
  "Nach Weinkarte filtern": "Filter by wine list",
  "Nach Kalenderjahr der Bewegungen filtern": "Filter by calendar year of movements",
  "Auswertung nach Flaschen oder Wert": "Evaluate by bottles or value",
  "Ein- & Auslagerungen nach Jahren": "Stock movements by year",
  "Weltkarte des Kellers": "World map of the cellar",
  "Weltkarte wird geladen …": "Loading world map …",
  "Keine Positionen mit Koordinaten für diese Auswahl.": "No entries with coordinates for this selection.",
  "Noch keine Daten.": "No data yet.",
  "Differenz": "Difference",
  "Aus dem Bewegungsprotokoll ab Aufzeichnungsbeginn — frühere Ein-/Auslagerungen sind nicht rekonstruierbar. Der Wert basiert auf dem hinterlegten Jahrgangspreis.": "From the movement log since recording began — earlier movements cannot be reconstructed. The value is based on the stored vintage price.",
  "Witterungsprofil des Jahrgangs": "Weather profile of the vintage",
  "Jahrgang wählen": "Choose vintage",
  "Vergleichsjahr": "Comparison year",
  "Vergleichsjahr wählen": "Choose comparison year",
  "Mit anderem Jahr vergleichen": "Compare with another year",
  "Lädt alle verfügbaren Jahre des Open-Meteo-Archivs in einem Abruf und berechnet die Mittelwerte.": "Loads all available years from the Open-Meteo archive in one request and computes the averages.",
  "Import abgeschlossen": "Import complete",
  "Beenden": "Finish",
  "Weine durchsuchen …": "Search wines …",
  "Einlagerung neu–alt": "Added, newest first",
  "Einlagerung alt–neu": "Added, oldest first",
  "Nach Weintyp": "By wine type",
  "Nach Zuckerkategorie": "By sweetness category",
  "Nach Ländern": "By country",
  "Nach Regionen": "By region",
  "Nach Rebsorten": "By grape variety",
  "Nach Winzern": "By producer",
  "Kellerbestand": "Cellar stock",
  "Weltkarte · {was}": "World map · {was}",
  "Nach Weintyp filtern": "Filter by wine type",
  "Nach Jahrgang filtern": "Filter by vintage",
  "Nach Winzer filtern": "Filter by producer",
  "Nach Lagerort filtern": "Filter by storage place",
  "Nach Trinkreife filtern": "Filter by drinking window",
  "Nach Lieblingsweinen filtern": "Filter by favourites",
  "Ohne Lagerort": "No storage place",
  "Keine Weine gefunden. Lege einen Wein an oder passe Suche und Filter an.": "No wines found. Add a wine or adjust search and filters.",
  "Länder": "Countries",
  "Winzer & Weine": "Producers & wines",
  "Regionen & Winzer": "Regions & producers",
  "ein Winzer": "1 producer",
  "{n} Winzer": "{n} producers",
  "eine Region": "1 region",
  "{n} Regionen": "{n} regions",
  "eine Flasche": "1 bottle",
  "{n} Flaschen": "{n} bottles",
  "Alle von {n} annehmen": "Accept all from {n}",
  "Alle von {n} ablehnen": "Reject all from {n}",
  "Ähnliche Einträge im Katalog": "Similar entries in the catalogue",
  "Annehmen und zusammenführen": "Accept and merge",
  "Getrennt lassen": "Keep separate",
  "Zusammenführen mit …": "Merge with …",
  "Bereits im Katalog": "Already in the catalogue",
  "In {n} Kellern": "In {n} cellars",
  "Ähnliche Einträge liegen schon im Katalog. Entscheide je Eintrag, ob zusammengeführt oder getrennt geführt wird — bis dahin wird nichts vorgeschlagen.": "Similar entries already exist in the catalogue. Decide for each whether to merge or keep it separate — until then nothing is proposed.",
  "Alle zusammenführen": "Merge all",
  "Alle getrennt lassen": "Keep all separate",
  "Offene Entscheidungen": "Pending decisions",
  "Keine offenen Entscheidungen.": "No pending decisions.",
  "Gilt für die Oberfläche sowie für Zahlen-, Datums- und Währungsangaben.": "Applies to the interface as well as number, date and currency formats.",

  /* Offline-Nutzung und Synchronisation */
  "Daten synchronisieren": "Synchronise data",
  "lokal": "local",
  "Lokale Änderungen · noch nicht übertragen": "Local changes · not yet uploaded",
  "Konflikt · bitte abgleichen": "Conflict · please synchronise",
  "Stände werden verglichen …": "Comparing versions …",
  "Beide Stände stimmen überein. Es war nichts zu übertragen.": "Both versions match. There was nothing to transfer.",
  "Die lokalen Änderungen wurden auf den Server übertragen.": "The local changes have been uploaded to the server.",
  "Der Serverstand war neuer und wurde übernommen.": "The server version was newer and has been applied.",
  "Der Server ist nicht erreichbar. Die Anwendung arbeitet mit dem lokalen Stand weiter; Änderungen bleiben auf diesem Gerät gesichert und werden beim nächsten erfolgreichen Abgleich übertragen.": "The server cannot be reached. The application continues with the local version; changes remain saved on this device and will be uploaded at the next successful synchronisation.",
  "Der Abgleich ist fehlgeschlagen.": "Synchronisation failed.",
  "Auf diesem Gerät und auf dem Server wurde seit dem letzten Abgleich jeweils etwas geändert. Beide Stände lassen sich nicht zusammenführen, ohne dass Angaben verloren gingen — bitte einen davon auswählen. Der andere wird überschrieben.": "Both this device and the server have changed since the last synchronisation. The two versions cannot be merged without losing entries — please choose one of them. The other will be overwritten.",
  "Dieses Gerät": "This device",
  "Server": "Server",
  "Letzte Bewegung": "Last movement",
  "Bewegungen": "Movements",
  "Serverstand {v}": "Server version {v}",
  "Achtung: Dieses Gerät hat kein gefülltes Kellerbuch. „Dieses Gerät behalten“ würde den Serverstand leeren.": "Caution: this device holds no filled cellar book. Choosing “Keep this device” would empty the server version.",
  "Achtung: Auf dem Server liegt kein gefülltes Kellerbuch. „Server behalten“ würde den hiesigen Stand verwerfen.": "Caution: the server holds no filled cellar book. Choosing “Keep server” would discard the version on this device.",
  "Später entscheiden": "Decide later",
  "Server behalten": "Keep server",
  "Dieses Gerät behalten": "Keep this device",

  /* Titel der Dialoge */
  "Info": "Info",
  "Region bearbeiten": "Edit region",
  "Winzer bearbeiten": "Edit producer",
  "Wein bearbeiten": "Edit wine",
  "Jahrgang bearbeiten": "Edit vintage",
  "Kritik bearbeiten": "Edit rating",
  "Entnahme": "Removal",
  "Zugang bearbeiten": "Edit stock addition",
  "Entnahme bearbeiten": "Edit removal",

  /* Etiketten offline */
  "wartet auf Übertragung": "pending upload",
  "Ein wartendes Etikett wurde übertragen.": "One pending label was uploaded.",
  "{n} wartende Etiketten wurden übertragen.": "{n} pending labels were uploaded.",
  "Ein Etikett wird im Hintergrund für den Offline-Betrieb geladen.": "One label is being fetched in the background for offline use.",
  "{n} Etiketten werden im Hintergrund für den Offline-Betrieb geladen.": "{n} labels are being fetched in the background for offline use.",
  "Ein Foto wartet auf Übertragung": "One photo is waiting to be uploaded",
  "{n} Fotos warten auf Übertragung": "{n} photos are waiting to be uploaded",
  "Wirklich löschen?": "Delete for good?",
  "Bewertet": "Rated",
  "Noch nichts erfasst. Sobald du Flaschen einlagerst, entnimmst oder eine Kritik schreibst, entsteht hier der Verlauf.": "Nothing recorded yet. As soon as you store or remove bottles, or write a rating, the history starts here.",
  "Datum der Entnahme": "date of removal",
  "Datum der zugehörigen Entnahme — die Kritik selbst ist undatiert": "Date of the matching removal — the rating itself is undated",

  /* Kritik erfassen und zuordnen */
  "Nicht zugeordnet": "Unassigned",
  "noch nicht zugeordnet": "not yet assigned",
  "Wein zuordnen": "Assign wine",
  "Ohne Angabe": "No details",
  "Kritik zuordnen": "Assign rating",
  "— Wein wählen —": "— Choose wine —",
  "＋ Neuen Wein anlegen": "＋ Add a new wine",
  "Noch nicht zuordnen": "Assign later",
  "Wein suchen oder wählen …": "Search or choose a wine …",
  "Wein (Notiz)": "Wine (note)",
  "Name des Weins": "Name of the wine",
  "＋ Neuen Winzer anlegen": "＋ Add a new producer",
  "Name des Winzers": "Name of the producer",
  "＋ Neuer Jahrgang": "＋ New vintage",
  "Jahr (leer = N.V.)": "Year (empty = N.V.)",
  "Zuordnen": "Assign",
  "Etikett fotografieren": "Photograph the label",
  "Anderes Bild": "Different image",
  "Wird übertragen …": "Uploading …",
  "Diese Kritik wartet noch auf ihren Wein. Wähle den passenden aus oder lege ihn neu an.": "This rating is still waiting for its wine. Pick the right one or create it.",
  "Erst der Eindruck, dann die Zuordnung: Wenn der Wein noch nicht feststeht, genügen ein Name und ein Foto des Etiketts.": "Impression first, filing afterwards: if the wine isn’t settled yet, a name and a photo of the label will do.",
  "Bitte wenigstens einen Namen oder Hinweis zum Wein angeben — sonst lässt sich die Kritik später nicht wiedererkennen.": "Please give at least a name or a hint about the wine — otherwise the rating cannot be recognised later.",
  "Bitte einen Namen für den Wein angeben.": "Please give the wine a name.",
  "Bitte einen Namen für den Winzer angeben.": "Please give the producer a name.",
  "Bitte eine Region für den neuen Winzer wählen.": "Please choose a region for the new producer.",
  "Bitte einen Wein wählen.": "Please choose a wine.",
  "Bitte ein gültiges Jahr angeben oder das Feld für N.V. leer lassen.": "Please give a valid year, or leave the field empty for N.V.",
  "Bitte den Kritiker bzw. die Quelle angeben.": "Please give the critic or source.",
  "Der Wert muss zwischen {min} und {max} liegen ({label}).": "The value must be between {min} and {max} ({label}).",
  "Dieser Jahrgang hat bereits ein Etikett — durch das neue ersetzen": "This vintage already has a label — replace it with the new one",
  "z. B. „Riesling, grünes Etikett, Mosel\"": "e.g. “Riesling, green label, Mosel”",
  "Kein Treffer für „{q}“": "No match for “{q}”",
  "Ohne Zuordnung anlegen": "Save without a wine",

  /* Zusammenführen: Feldvergleich */
  "Merkmal": "Attribute",
  "gleich": "same",
  "wird ergänzt": "will be added",
  "abweichend": "differs",
  "ohne weitere Angaben": "no further details",
  "Rohdaten anzeigen": "Show raw data",
  "Rohdaten ausblenden": "Hide raw data",
  "Keine widersprüchlichen Angaben — beim Zusammenführen bleibt alles erhalten und beide Seiten ergänzen sich.": "No conflicting details — merging keeps everything and the two sides complete each other.",
  "Eine Angabe widerspricht sich. Sie wird vom Ziel übernommen, die der Quelle geht verloren.": "One detail conflicts. The target's value is kept; the source's is lost.",
  "{n} Angaben widersprechen sich. Sie werden vom Ziel übernommen, die der Quelle gehen verloren.": "{n} details conflict. The target's values are kept; the source's are lost.",
  "Eine abweichende Angabe der Quelle geht dabei verloren.": "One differing detail of the source will be lost.",
  "{n} abweichende Angaben der Quelle gehen dabei verloren.": "{n} differing details of the source will be lost.",
  "Eigenes Label": "Own label",
  "Trinkfenster ab": "Drinking window from",
  "Breite": "Latitude",
  "Länge": "Longitude",
  "＋ Neue Region anlegen": "＋ Add a new region",
  "Bitte einen Namen für die neue Region angeben.": "Please give the new region a name.",
  "Bitte gültige Koordinaten für die neue Region angeben (Dezimalgrad).": "Please give valid coordinates for the new region (decimal degrees).",
  "Trinkreife ab · früh zuerst": "Drinking window from · earliest first",
  "Trinkreife ab · spät zuerst": "Drinking window from · latest first",
  "Trinkreife bis · früh zuerst": "Drinking window to · earliest first",
  "Trinkreife bis · spät zuerst": "Drinking window to · latest first",

  /* Altbestand freigeben */
  "Lokal geführt": "Kept locally",
  "Für den Katalog freigeben": "Release to the catalogue",
  "{n} Region": "{n} region",
  "Wirklich {n} Eintrag freigeben?": "Really release {n} entry?",
  "Wirklich {n} Einträge freigeben?": "Really release {n} entries?",
  "waren beim Einführen des Katalogs bereits vorhanden. Solche Angaben werden absichtlich nicht vorgeschlagen — sonst hätte der erste Abgleich das halbe Kellerbuch auf einmal vorgelegt. Willst du sie gemeinsam pflegen, gib sie hier frei.": "were already present when the catalogue was introduced. Such entries are deliberately never proposed — otherwise the first reconciliation would have submitted half your cellar book at once. If you want to maintain them jointly, release them here.",
  "Winzer und Region eines Weins gehen dabei mit; ohne sie wäre der Eintrag im Katalog unbrauchbar. Liegt derselbe Wein dort schon unter anderer Kennung, entsteht ein zweiter Eintrag — dafür gibt es das Zusammenführen.": "A wine takes its producer and region along; without them the catalogue entry would be useless. If the same wine already sits there under a different identifier, a second entry appears — that is what merging is for.",
  "Ein weiterer Eintrag wurde einmal abgelehnt und bleibt dauerhaft lokal.": "One further entry was rejected once and stays local for good.",
  "{n} weitere Einträge wurden einmal abgelehnt und bleiben dauerhaft lokal.": "{n} further entries were rejected once and stay local for good.",
  "Speichern fehlgeschlagen": "Saving failed",

  /* Nachgetragen (Prüfung tests/i18n.test.mjs) */
  "Label": "Label",
  "Wein auf der Karte suchen …": "Search a wine on the list …",
  "Kein Wein auf der Karte passt zur Suche.": "No wine on the list matches the search.",
  "Gliederung": "Structure",
  "Land → Region → Winzer → Weine": "Country → Region → Producer → Wines",
  "Label → Land → Region → Winzer → Weine": "Label → Country → Region → Producer → Wines",
  "Inhaltsverzeichnis (Länder & Regionen)": "Table of contents (countries & regions)",
  "Seitenzahlen": "Page numbers",
  "PDF herunterladen": "Download PDF",
  "Suchen (Wein, Winzer, Region) …": "Search (wine, producer, region) …",
  "{n} von {m} angezeigt — weiter scrollen für mehr": "{n} of {m} shown — scroll on for more",
  "Im Katalog verfügbar": "Available in the catalogue",
  "Aus dem Katalog übernommen:": "Taken from the catalogue:",
  "Verknüpfung mit dem Katalog": "link to the catalogue",
  "pH": "pH",

  /* Kritik-Einstellungen */
  "Standard-Bewertungsschema": "Default rating scale",
  "Meine Kritiken im gemeinsamen Katalog zeigen": "Show my ratings in the shared catalogue",
  "Bewertung, Kritiker, Anlass, Speisenbegleitung und Verkostungsnotiz sind für alle Konten sichtbar, zusammen mit deinem Benutzernamen. Bestände, Lagerorte und Preise niemals.": "Rating, critic, occasion, food pairing and tasting note are visible to all accounts, together with your user name. Stock, storage locations and prices never are.",
  "Deine Kritiken bleiben in deinem Kellerbuch und erscheinen bei keinem anderen Konto.": "Your ratings stay in your cellar book and appear in no other account.",
  "Gespeichert.": "Saved.",
  "Das hat nicht geklappt.": "That did not work.",
  "Eigene Kritik": "Own rating",
  "Mein Keller": "My cellar",
  "Suchbereich": "Search scope",
  "geteilt": "shared",
  "Suche löschen": "Clear search",
  "Umfang der Listen": "Scope of the lists",
  "Anzeigen": "Show",
  "Keller mit Bestand": "Cellar with stock",
  "Gesamter Keller": "Entire cellar",
  "Nur eigene Kritiken zeigen": "Show only my own ratings",
  "Alle Kritiken einblenden (eine weitere)": "Show all ratings (one more)",
  "Alle Kritiken einblenden ({n} weitere)": "Show all ratings ({n} more)",
  "Du hast diesen Wein noch nicht bewertet.": "You have not rated this wine yet.",
  "Im gemeinsamen Katalog zeigen": "Show in the shared catalogue",
  "Bewertung, Kritiker, Anlass, Pairing und Notiz sind für alle Konten sichtbar — samt deinem Benutzernamen. Bestände, Lagerorte und Preise niemals.": "Rating, critic, occasion, pairing and note are visible to all accounts — together with your user name. Stock, storage locations and prices never are.",
  "Deine Kritiken bleiben in deinem Kellerbuch.": "Your ratings stay in your cellar book.",
  "Bewertung, Kritiker, Speisenbegleitung und Notiz sind für alle Konten sichtbar — samt deinem Benutzernamen. Der Anlass bleibt privat, ebenso Bestände, Lagerorte und Preise.": "Rating, critic, food pairing and note are visible to all accounts — together with your user name. The occasion stays private, as do stock, storage locations and prices.",

  /* Jahrgänge mit ähnlicher Witterung */
  "Jahrgänge mit ähnlicher Witterung in {region}": "Vintages with similar weather in {region}",
  "sehr ähnlich": "very similar",
  "gut vergleichbar": "well comparable",
  "in Teilen ähnlich": "partly similar",
  "gering ähnlich": "loosely similar",
  "nahezu deckungsgleich": "almost identical",
  "wärmer": "warmer",
  "später reif": "later to ripen",
  "früher reif": "earlier to ripen",
  "Tage": "days",
  "kühler": "cooler",
  "nasser": "wetter",
  "trockener": "drier",
  "sonniger": "sunnier",
  "trüber": "duller",
  "Bodenwasser Periodenende": "Soil water at end of season",

  /* Witterung: Abruf und Kennzahlen im Vergleich */
  "Witterung abrufen": "Fetch weather",
  "Neu abrufen": "Fetch again",
  "Abrufen": "Fetch",
  "Klimareihe laden": "Load climate series",
  "Klimareihe aktualisieren": "Update climate series",
  "Klimareihe wird geladen …": "Loading climate series …",
  "Ø letzte 10 Jahre": "Ø last 10 years",
  "Ø alle Jahre": "Ø all years",
  "Ø Temperatur": "Ø temperature",
  "Ø Höchsttemperatur": "Ø maximum temperature",
  "Ø Tiefsttemperatur": "Ø minimum temperature",
  "Sonnenstunden": "Sunshine hours",
  "Gradtage (Basis 10 °C)": "Growing degree days (base 10 °C)",
  "Hitzetage ≥ 30 °C": "Hot days ≥ 30 °C",
  "Jahrgang {jahr} ist abgeschlossen, fehlt aber noch in der geladenen Klimareihe — „Klimareihe aktualisieren“ nimmt ihn in Vergleich und Stilprofil auf.": "Vintage {jahr} is complete but not yet in the loaded climate series — “Update climate series” adds it to the comparison and the style profile.",
  "Reiferegen noch hochgerechnet — die Tage nach der Reife liegen jetzt im Archiv. „Klimareihe aktualisieren“ ersetzt die Schätzung.": "Ripening rain still extrapolated — the days after ripeness are now in the archive. “Update climate series” replaces the estimate.",
  "Reiferegen noch hochgerechnet — die Tage nach der Reife fehlen im Archiv. Ab {datum} „Klimareihe aktualisieren“.": "Ripening rain still extrapolated — the days after ripeness are not yet in the archive. From {datum}, use “Update climate series”.",
  "Diese Klimareihe stammt aus einer älteren Fassung — einmal „Klimareihe aktualisieren“, damit Vergleich und Stilprofil neu gerechnet werden.": "This climate series comes from an older version — use “Update climate series” once so that the comparison and the style profile are recalculated.",

  /* Stilprofil */
  "Stilprofil {jahr}": "Style profile {jahr}",
  "Reife geschätzt: {datum}": "Ripeness estimated: {datum}",
  "im Mittel der Region: {datum}": "regional average: {datum}",
  "Wärme": "Warmth",
  "Nächte in der Reife": "Nights during ripening",
  "Regen in der Reife": "Rain during ripening",
  "Bodenwasser am Ende": "Soil water at the end",
  "Bodenwasser zur Reife": "Soil water at ripeness",
  "sehr kühl": "very cool",
  "kühl": "cool",
  "typisch": "typical",
  "warm": "warm",
  "sehr warm": "very warm",
  "mild": "mild",
  "sehr mild": "very mild",
  "sehr trocken": "very dry",
  "trocken": "dry",
  "feucht": "damp",
  "sehr nass": "very wet",
  "ausgetrocknet": "depleted",
  "knapp": "scarce",
  "reichlich": "ample",
  "sehr reichlich": "very ample",
  "Hitzejahr: opulent und alkoholreich, die Säure wird knapp": "Heat year: opulent and high in alcohol, acidity runs short",
  "Reife mit Frische: warme Tage, kühle Nächte — volle Reife bei erhaltener Säure": "Ripeness with freshness: warm days, cool nights — full ripeness with acidity retained",
  "Kühl und nass: schlank, säurebetont, stark von der Selektion abhängig": "Cool and wet: lean, acid-driven, heavily dependent on selection",
  "Volle Reife, mehr Körper und Alkohol, weichere Säure": "Full ripeness, more body and alcohol, softer acidity",
  "Schlank und säurebetont, eher niedriger Alkohol": "Lean and acid-driven, rather low alcohol",
  "Kühle Nächte bewahren Frische, Aromatik und Farbe": "Cool nights preserve freshness, aromatics and colour",
  "Milde Nächte: weichere Frucht, Aromatik eher reif als frisch": "Mild nights: softer fruit, aromatics ripe rather than fresh",
  "Regen zur Reife: Verdünnungs- und Fäulnisgefahr": "Rain at ripening: risk of dilution and rot",
  "Trockene Reife: gesundes Lesegut": "Dry ripening: healthy fruit",
  "Trockenstress: kleine Beeren, dicke Schalen, Konzentration und Tannin": "Drought stress: small berries, thick skins, concentration and tannin",
  "Gute Wasserversorgung: größere Beeren, zugänglicher Stil": "Good water supply: larger berries, a more approachable style",
  "Ein für die Region typischer Jahrgang ohne ausgeprägte Richtung": "A vintage typical of the region with no marked direction",
  /* Katalogabgleich: Vorschläge, Änderungen, Sync-Bericht */
  "(ohne Namen)": "(unnamed)",
  "Ablehnen (+{n} abhängige)": "Reject (+{n} dependent)",
  "Angenommene Vorschläge gehen in den Katalog und stehen allen Cloud-Konten zur Verfügung. Übernommen wird nur, was der Vorschlag ändert; fehlende Winzer und Regionen gehen mit, wenn sie selbst vorgeschlagen sind. Eine abgelehnte Aufnahme bleibt beim Vorschlagenden dauerhaft lokal, eine abgelehnte Änderung nur in dieser Fassung.": "Accepted proposals go into the catalogue and are available to all cloud accounts. Only what the proposal changes is applied; missing producers and regions come along if they have been proposed themselves. A rejected addition stays local for good with the person who proposed it; a rejected change only in that version.",
  "Dein Eintrag wird auf die Katalogfassung zurückgesetzt. Bestände, Lagerorte und Preise bleiben.": "Your entry is reset to the catalogue version. Stock, locations and prices stay.",
  "Deine Fassung bleibt bei dir stehen; der Eintrag bleibt mit dem Katalog verbunden und bekommt weitere Änderungen mit.": "Your version stays with you; the entry remains linked to the catalogue and keeps receiving further changes.",
  "Deine Fassung → Katalogfassung": "Your version → catalogue version",
  "Der Eintrag steht nicht mehr im Katalog — vermutlich wurde er zusammengeführt. Annehmen ist nicht möglich.": "The entry is no longer in the catalogue — it was probably merged. It cannot be accepted.",
  "Der Eintrag wird danach nur bei dir geführt. Unter „Lokal geführt“ kannst du ihn später wieder freigeben.": "The entry will then be kept only on your side. You can release it again later under “Kept locally”.",
  "Der Katalog war nicht erreichbar; das holt der nächste Abgleich nach.": "The catalogue could not be reached; the next sync will catch up.",
  "Der Katalog wurde seit dem Vorschlag geändert, aber an anderen Stellen. Angenommen wird nur, was dieser Vorschlag ändert.": "The catalogue has changed since the proposal, but elsewhere. Only what this proposal changes will be accepted.",
  "Der Katalog wurde seit dem Vorschlag geändert. Markierte Felder hat auch jemand anderes geändert — beim Annehmen gilt dieser Vorschlag.": "The catalogue has changed since the proposal. Someone else also changed the marked fields — accepting applies this proposal.",
  "Diese Einträge verweisen auf einen Winzer oder eine Region, die nur bei dir geführt werden. Im Katalog wären sie unbrauchbar — gib den Bezug unten unter „Lokal geführt“ frei, dann gehen sie beim nächsten Abgleich mit.": "These entries refer to a producer or region that is kept only on your side. In the catalogue they would be unusable — release the reference below under “Kept locally” and they will go along with the next sync.",
  "Ein Eintrag im Katalog zusammengeführt.": "One catalogue entry merged.",
  "{n} Einträge im Katalog zusammengeführt.": "{n} catalogue entries merged.",
  "Ein Vorschlag wurde abgelehnt.": "One proposal was rejected.",
  "{n} Vorschläge wurden abgelehnt.": "{n} proposals were rejected.",
  "Ein Vorschlag wurde angenommen.": "One proposal was accepted.",
  "{n} Vorschläge wurden angenommen.": "{n} proposals were accepted.",
  "Ein neuer Vorschlag ging an den Verwalter.": "One new proposal went to the administrator.",
  "{n} neue Vorschläge gingen an den Verwalter.": "{n} new proposals went to the administrator.",
  "Eine Katalogänderung weicht von deiner Fassung ab — siehe Katalog → Änderungen.": "One catalogue change differs from your version — see Catalogue → Changes.",
  "{n} Katalogänderungen weichen von deiner Fassung ab — siehe Katalog → Änderungen.": "{n} catalogue changes differ from your version — see Catalogue → Changes.",
  "Eine Katalogänderung übernommen.": "One catalogue change applied.",
  "{n} Katalogänderungen übernommen.": "{n} catalogue changes applied.",
  "Hängt an einem abgelehnten Winzer oder einer abgelehnten Region.": "Depends on a rejected producer or region.",
  "Im Katalog wurden zwei Einträge vereint — deine Bestände und Verweise sind mitgewandert.": "Two catalogue entries were merged — your stock and references moved along.",
  "In Prüfung": "Under review",
  "in Prüfung": "under review",
  "Jahrgang entfernt": "vintage removed",
  "neuer Jahrgang": "new vintage",
  "Katalog befüllt": "catalogue filled",
  "Katalog wird abgeglichen …": "Syncing catalogue …",
  "Katalog: nichts Neues.": "Catalogue: nothing new.",
  "Katalogfassung wiederherstellen": "Restore catalogue version",
  "Keine inhaltliche Änderung erkennbar.": "No change in content detected.",
  "Korrektur verwerfen": "Discard correction",
  "Korrigieren": "Correct",
  "Mit Korrektur annehmen": "Accept with correction",
  "Laden fehlgeschlagen.": "Loading failed.",
  "Legst du im Cloud-Modus einen Wein, Winzer oder eine Region an oder änderst etwas daran, wird das dem Verwalter des Katalogs vorgelegt. Bis zur Entscheidung arbeitest du ungehindert mit deiner eigenen Fassung weiter.": "If you add or change a wine, producer or region in cloud mode, it is put to the catalogue administrator. Until a decision is made you carry on with your own version without restriction.",
  "Meine behalten": "Keep mine",
  "Nichts zu entscheiden.": "Nothing to decide.",
  "Wirklich zurückziehen?": "Really withdraw?",
  "Zu entscheiden": "To decide",
  "Zuletzt eingespielt": "Recently applied",
  "Zurückgehalten": "Held back",
  "Zurückziehen": "Withdraw",
  "auch im Katalog geändert": "also changed in the catalogue",
  "davon {n} als Bezug mitgenommen": "{n} of them taken along as references",
  "davon {n} als Folge": "{n} of them as a consequence",
  "durch {n}": "by {n}",
  "von {n}": "from {n}",
  "entfernt": "removed",
  "geändert": "changed",
  "neu aufgenommen": "newly added",
  "neu": "new",
  "unbekannt": "unknown",
  "veraltet": "outdated",
  "vorhanden": "present",
  "werden nur bei dir geführt — weil sie beim Einführen des Katalogs schon vorhanden waren oder weil du einen Vorschlag zurückgezogen hast. Solche Angaben werden nicht vorgeschlagen. Willst du sie gemeinsam pflegen, gib sie hier frei.": "are kept only on your side — because they already existed when the catalogue was introduced, or because you withdrew a proposal. Such entries are not proposed. If you want to maintain them together, release them here.",
  "zusammengeführt": "merged",
  "{n} abgelehnt": "{n} rejected",
  "{n} angenommen": "{n} accepted",
  "{typ} „{name}“ fehlt im Katalog und wartet nicht als Vorschlag — so nicht annehmbar.": "{typ} “{name}” is missing from the catalogue and is not waiting as a proposal — cannot be accepted like this.",
  "{typ} „{name}“ wartet selbst auf Prüfung und wird beim Annehmen mitgenommen.": "{typ} “{name}” is itself awaiting review and will be taken along on acceptance.",
  "Änderungen am gemeinsamen Katalog, die deine Weine, Winzer oder Regionen betreffen. Wo deine Fassung noch dem alten Stand entsprach, wurde still nachgezogen. Bestände, Lagerorte und Preise bleiben immer unberührt.": "Changes to the shared catalogue that affect your wines, producers or regions. Where your version still matched the old state, it was quietly updated. Stock, locations and prices always stay untouched.",
  "Beschreibung": "Description",
  "angenommen": "accepted",
  "abgelehnt": "rejected",
  "Aufnahme": "Addition",
  "Änderung": "Change",
  "übernommen": "applied",
  "lokal geführt": "kept locally",
  "bereits aktuell": "already up to date",
  /* Katalogabgleich: Aufnahme mit eigener Fassung */
  "deine Fassung bleibt": "your version stays",
  "Du hast seit deinem Vorschlag weiter daran gearbeitet. Deine neuere Fassung bleibt und geht als Änderung an den Verwalter.": "You kept working on it after your proposal. Your newer version stays and goes to the administrator as a change.",
  /* Katalogabgleich: Dreiwegevergleich */
  "Hier hat der Katalog ein Feld geändert, das du selbst anders geändert hast. Alles Übrige ist bereits übernommen. „Meine behalten“ lässt deine Angabe stehen; sie geht dann als Änderungsvorschlag an den Verwalter.": "Here the catalogue changed a field that you changed differently yourself. Everything else has already been applied. “Keep mine” leaves your entry in place; it then goes to the administrator as a proposed change.",
  /* Kellerbuch-Abgleich: Zusammenführen */
  "Auf beiden Seiten gab es Änderungen. Sie widersprachen sich nicht und wurden zusammengeführt.": "There were changes on both sides. They did not contradict each other and were merged.",
  "Auf diesem Gerät und auf dem Server wurde seit dem letzten Abgleich jeweils etwas geändert. Alles, was sich nicht widerspricht, wird zusammengeführt. An diesen Stellen haben beide Seiten dasselbe verschieden geändert:": "Since the last sync, something was changed both on this device and on the server. Everything that does not contradict is merged. In these places both sides changed the same thing differently:",
  "Auf diesem Gerät und auf dem Server wurde seit dem letzten Abgleich jeweils etwas geändert. Ohne gemeinsamen Ausgangsstand lassen sich beide nicht sicher zusammenführen — bitte einen davon auswählen. Der andere wird überschrieben.": "Since the last sync, something was changed both on this device and on the server. Without a common starting point the two cannot be merged safely — please choose one. The other will be overwritten.",
  "Bestand {g}": "Stock {g}",
  "Ein Stand wird ganz übernommen, der andere überschrieben — auch dort, wo sich nichts widerspricht.": "One version is taken over entirely and the other overwritten — even where nothing contradicts.",
  "Ein Widerspruch · Serverstand {v}": "One conflict · server version {v}",
  "{n} Widersprüche · Serverstand {v}": "{n} conflicts · server version {v}",
  "Stattdessen einen Stand ganz übernehmen": "Take over one version entirely instead",
  "Von diesem Gerät: {a} · vom Server: {b}": "From this device: {a} · from the server: {b}",
  "Zusammenführen, Server gilt": "Merge, server wins",
  "Zusammenführen, dieses Gerät gilt": "Merge, this device wins",
  "gelöscht": "deleted",
  "ja": "yes",
  "nein": "no",
  "nur auf dem Server": "only on the server",
  "nur hier": "only here",
  "verschieden": "different",
  "… und {n} weitere": "… and {n} more",
  "Beide Stände wurden zusammengeführt; beim einen Widerspruch gilt der Server.": "Both versions were merged; for the one conflict the server wins.",
  "Beide Stände wurden zusammengeführt; beim einen Widerspruch gilt dieses Gerät.": "Both versions were merged; for the one conflict this device wins.",
  "Beide Stände wurden zusammengeführt; bei {n} Widersprüchen gilt der Server.": "Both versions were merged; for {n} conflicts the server wins.",
  "Beide Stände wurden zusammengeführt; bei {n} Widersprüchen gilt dieses Gerät.": "Both versions were merged; for {n} conflicts this device wins.",
  "Bewegung": "Movement",
  "Einstellung": "Setting",
  "Katalogabweichung": "Catalogue deviation",
  "Favorit": "Favourite",
  "Trinkreife ab": "Drinkable from",
  "Trinkreife bis": "Drinkable until",
  "Dieses Gerät hat lange nicht abgeglichen — ein Teil des Katalogprotokolls liegt nicht mehr vor. Was von der Katalogfassung abweicht, steht zur Entscheidung unter Katalog → Änderungen, statt als Vorschlag gesendet zu werden.": "This device has not synced for a long time — part of the catalogue log is no longer available. Anything that differs from the catalogue version is listed for your decision under Catalogue → Changes instead of being sent as a suggestion.",
  "Eine eigene Änderung ging direkt in den Katalog.": "One of your changes went straight into the catalogue.",
  "{n} eigene Änderungen gingen direkt in den Katalog.": "{n} of your changes went straight into the catalogue.",
  "Lokale Kopie konnte nicht gespeichert werden": "Local copy could not be saved",
  "Alle von {n} annehmen (ohne {k} mit Dublettenverdacht)": "Accept all from {n} (except {k} suspected duplicates)",
  "Ein Vorschlag mit Dublettenverdacht bleibt zur Einzelprüfung offen.": "One suggestion suspected to be a duplicate remains open for individual review.",
  "{n} Vorschläge mit Dublettenverdacht bleiben zur Einzelprüfung offen.": "{n} suggestions suspected to be duplicates remain open for individual review.",
  "Mit Korrektur trotzdem neu aufnehmen": "Add as new anyway, with correction",
  "Mit „{name}“ zusammenführen": "Merge with “{name}”",
  "Trotzdem neu aufnehmen": "Add as new anyway",
  "möglich": "possible",
  "wahrscheinlich Dublette": "likely duplicate",
  "wahrscheinlich dieselbe": "likely the same",
  "Alle wahrscheinlichen zusammenführen ({n})": "Merge all likely ones ({n})",
  "mögliche Dublette": "possible duplicate",
  "Ähnliche Einträge liegen schon im Katalog. Entscheide je Eintrag, ob zusammengeführt oder getrennt geführt wird. Eine wahrscheinliche Dublette wird bis dahin nicht vorgeschlagen, eine mögliche schon.": "Similar entries already exist in the catalogue. Decide for each entry whether to merge or keep it separate. A likely duplicate is not suggested until then; a possible one is.",
  "Name gleich": "same name",
  "Name ähnlich": "similar name",
  "Lage nur bei einem": "site named on one side only",
  "Land gleich": "same country",
  "Region gleich": "same region",
  "andere Region": "different region",
  "Ort gleich": "same village",
  "gleicher Winzer": "same producer",
  "Winzer nur bei einem": "producer known on one side only",
  "Typ gleich": "same type",
  "+ {n} weitere": "+ {n} more",
  "Alle {n} zeigen": "Show all {n}",
  "Weitere {n} zeigen": "Show {n} more",
  "weniger": "less",
  "{n} von {gesamt}": "{n} of {gesamt}",
  /* Mehrfachauswahl in Filtern */
  "Suchen …": "Search …",
  "Keine Treffer": "No matches",
  /* Rundum-Etikett (3D) */
  "Rundum aufnehmen (3D)": "Capture all-round (3D)",
  "Rundum-Etikett": "All-round label",
  "Ziehen dreht die Flasche · zwei Finger, Mausrad oder Doppeltippen vergrößern": "Drag to turn the bottle · pinch, scroll wheel or double-tap to zoom",
  "Kein Zugriff auf die Kamera. Bitte den Zugriff in den Einstellungen des Browsers erlauben.": "No access to the camera. Please allow access in your browser settings.",
  "Es wurde keine Kamera gefunden.": "No camera was found.",
  "Die Kamera konnte nicht gestartet werden.": "The camera could not be started.",
  "Die Kamera ist in diesem Browser nicht verfügbar.": "The camera is not available in this browser.",
  "Die Aufnahme ist fehlgeschlagen.": "The capture failed.",
  "Der Upload ist fehlgeschlagen.": "The upload failed.",
  "Etwas langsamer drehen": "Turn a little more slowly",
  "Flasche weiterdrehen": "Keep turning the bottle",
  "Es wurde keine volle Umdrehung erkannt. Bitte die Flasche ganz herumdrehen, bis der Balken voll ist, und dabei im Umriss halten.": "No full turn was detected. Please turn the bottle all the way round until the bar is full, keeping it inside the outline.",
  "Flasche in den Umriss stellen. Telefon ruhig halten, am besten aufgestützt.": "Place the bottle inside the outline. Hold the phone still, ideally propped up.",
  "Flasche erkannt. Start tippen und die Flasche langsam einmal ganz herumdrehen — umgreifen ist erlaubt.": "Bottle detected. Tap Start and slowly turn the bottle once all the way round — changing your grip is fine.",
  "Wird berechnet …": "Calculating …",
  "Langsam drehen, bis der Balken voll ist": "Turn slowly until the bar is full",
  "Flasche nicht erkannt — bitte im Umriss halten": "Bottle not detected — please keep it inside the outline",
  "Der Umriss der Flasche war nicht sicher zu erkennen. Hals und Kapsel folgen der gewählten Form und können verzerrt sein.": "The outline of the bottle could not be detected reliably. Neck and capsule follow the selected shape and may be distorted.",
  "Fertig": "Done",
  "Rundum-Etikett prüfen": "Check all-round label",
  "Vorschau des Rundum-Etiketts": "Preview of the all-round label",
  "Kapsellänge": "Capsule length",
  "Die Kapselkante war nicht eindeutig zu erkennen. Bitte mit dem Regler an die Linie anpassen.": "The edge of the capsule could not be detected clearly. Please adjust the line with the slider.",
  "Einzelne Stellen wurden ergänzt. Langsameres Drehen ergibt ein schärferes Bild.": "Some areas were filled in. Turning more slowly gives a sharper image.",
  "Wiederholen": "Retake",
  "Rundum-Etikett aufnehmen": "Capture all-round label",
  "Flaschenform": "Bottle shape",
  "Start": "Start",
  "Neu beginnen": "Start over",
  "Zum Drehen ziehen": "Drag to turn",
  "Folie": "Foil",
  "Wachs": "Wax",
  "Schraubverschluss": "Screw cap",
  "Ohne Kapsel": "No capsule",
  "Bitte mindestens drei Fotos wählen, besser sechs rundum.": "Please choose at least three photos, ideally six all round.",
  "Auf Foto {n} wurde keine Flasche erkannt. Die ganze Flasche sollte aufrecht im Bild stehen.": "No bottle was detected in photo {n}. The whole bottle should stand upright in the frame.",
  "Foto {n} passt zu keinem anderen Foto. Zwischen zwei Fotos die Flasche nur um etwa ein Sechstel weiterdrehen.": "Photo {n} does not match any other photo. Turn the bottle by only about a sixth between two photos.",
  "Die Fotos zeigen die Flasche nicht von allen Seiten. Bitte rundum fotografieren, etwa alle 60°.": "The photos do not show the bottle from all sides. Please photograph it all round, about every 60°.",
  "Die Berechnung ist fehlgeschlagen.": "The calculation failed.",
  "Einzelne Stellen sind nur von der Seite zu sehen und unscharf. Mehr Fotos rundum helfen.": "Some areas are only seen from the side and are blurred. More photos all round help.",
  "Fotos aufnehmen oder auswählen — am besten sechs rundum.": "Take or choose photos — ideally six all round.",
  "Ein Foto. Mindestens drei, besser sechs.": "One photo. At least three, ideally six.",
  "{n} Fotos. Mindestens drei, besser sechs.": "{n} photos. At least three, ideally six.",
  "{n} Fotos. Berechnen tippen.": "{n} photos. Tap Calculate.",
  "Flasche auf eine Fläche stellen. Gleichmäßiges Licht, kein Blitz.": "Stand the bottle on a surface. Even light, no flash.",
  "Telefon etwa auf Höhe der Flaschenmitte, die ganze Flasche im Bild.": "Hold the phone at about the middle of the bottle, with the whole bottle in the frame.",
  "Nach jedem Foto die Flasche um etwa 60° weiterdrehen, immer in dieselbe Richtung, am Bauch angefasst (eine lose Kapsel dreht sonst mit) — sechs Fotos rundum.": "After each photo turn the bottle by about 60°, always in the same direction, holding it by the body (a loose capsule would otherwise turn with your fingers) — six photos all round.",
  "Foto {n}": "Photo {n}",
  "Foto {n} entfernen": "Remove photo {n}",
  "Foto 1 ist die Vorderseite: mit dem Vorderetikett in der Mitte beginnen. Die Fotos lassen sich durch Ziehen umsortieren.": "Photo 1 is the front: start with the front label in the middle. Drag the photos to reorder them.",
  "Foto {n}, Vorderseite": "Photo {n}, front",
  "Zum Verschieben ziehen oder Pfeiltasten.": "Drag or use the arrow keys to move.",
  "Foto jetzt an Stelle {n}.": "Photo now in position {n}.",
  "vorne": "front",
  "Foto aufnehmen": "Take photo",
  "Fotos auswählen": "Choose photos",
  "Aufnahmeart": "Capture method",
  "Video": "Video",
  "Fotos": "Photos",
  "Berechnen": "Calculate",
  "Etikettfoto zeigen": "Show label photo",
  "3D-Ansicht zeigen": "Show 3D view",
  "Die Flasche hat die Form {form}. Die Form wurde angepasst.": "The bottle has the {form} shape. The shape has been adjusted.",
};

export { texte };
